// index.tsx
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import App from './App'
import { store } from './redux'
import { theme } from './theme'
import './license'
import './global.css'
import { SessionTimeoutProvider } from './providers/SessionTimeoutProvider'
import ExternalRedirectProvider from './components/AppShell/ExternalRedirectProvider'

const persistor = persistStore(store)

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <SessionTimeoutProvider>
              <ExternalRedirectProvider>
                <App />
              </ExternalRedirectProvider>
            </SessionTimeoutProvider>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
